import React, { useEffect, useState } from 'react'
import {
  activity_dates,
  topNumber,
} from '../../../constants/activity-constants'
import { WORDS } from '../../../constants/keywords'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { navigate } from 'gatsby'
import useCallModal from '../../../utils/callModal'
import { StaticImage } from 'gatsby-plugin-image'
import { getUserData, getUserInfo, requestTopInfo } from './data-store'
import Button from '../../atoms/button/button'
import formatStringDate from '../../../utils/formatStringDate'
import updateConcourseDates from '../../../utils/updateConcurseDates'
const TOTAL_WINNERS = topNumber
const handlerGoToRegister = () => {
  window.open(siteUrl + '/registro', '_BLANK')
}
function Alink({
  children,
  onClick,
  href = null,
  target = '_blank',
  tag = null,
}) {
  return (
    <a
      className={'--link '}
      rel="noopener noreferrer"
      href={href}
      target={target}
      onClick={e => {
        onClick && onClick(e)
        e.preventDefault()
        return false
      }}
      tag={tag}
    >
      {children}
    </a>
  )
}
function TopTitle({ isMobile }) {
  const imageProps = {
    src: '../../../assets/images/top-title.png',
    className: '',
    alt: 'Top jugadoras',
    placeholder: 'blurred',
  }
  if (isMobile) {
    return <StaticImage {...imageProps} height={55} />
  }
  return <StaticImage {...imageProps} height={64} />
}

function IconTitle({ isMobile }) {
  const imageProps = {
    src: '../../../assets/images/logo.png',
    className: 'f-top-section__title__icon',
    alt: 'icono jugadora panty con banderin',
    placeholder: 'blurred',
  }
  if (isMobile) {
    return <StaticImage {...imageProps} height={46} />
  }
  return <StaticImage {...imageProps} height={64} />
}
export function ViewNotLoged({}) {
  const [callModal] = useCallModal()
  const handleCallLogin = () => {
    callModal(
      'login',
      {},
      {
        className: 'fondo',
      }
    ).then(logged => {
      if (logged) {
        window.location.reload()
      }
    })
  }
  return (
    <div className="f-top-section__side__top-container__content">
      <p>
        <Alink tag="7A" onClick={handleCallLogin}>
          {WORDS.inicia_sesion}
        </Alink>{' '}
        para conocer tu puntuaje y tu posición dentro del top de jugadoras.
      </p>
      <p>
        Si aún no {WORDS.formas} parte de{' '}
        <Alink tag="7A" href={siteUrl}>
          NosotrasOnline
        </Alink>{' '}
        {WORDS.registrate}{' '}
        <Alink tag="7A" href={siteUrl + '/registro'}>
          {' '}
          {WORDS.aqui}
        </Alink>
      </p>
      <p className="--bold">
        ¡Tú tienes el potencial para estar entre las {TOTAL_WINNERS} mejores!
        Corre a participar.
      </p>
    </div>
  )
}

function ScoreBox({ text, value }) {
  return (
    <div className="score-box">
      <p className="score-box__text">{text}</p>
      <p className="score-box__value">{value}</p>
    </div>
  )
}
updateConcourseDates()
export function ViewLogged({ userInfo, ready }) {
  const [userData, setUserData] = useState(getUserData())
  const [dirty, setDirty] = useState(false)
  useEffect(() => {
    if (ready) {
      updateConcourseDates().then(() => {
        setDirty(!dirty)
      })
      requestTopInfo().then(() => {
        setUserData(getUserData())
      })
    }
  }, [ready])
  return (
    <div className="view-logged flex --column --center">
      <h3 className="--capitalize">Hola {userInfo?.name.split(' ')[0]}</h3>
      <br />
      <div className="container-points">
        <ScoreBox text={'Tus puntos'} value={userData.point} />
        <ScoreBox text={'Tu puesto'} value={userData.position} />
      </div>
      <p>
        <br />
        Si no estás en nuestro top {TOTAL_WINNERS}, ¡sigue jugando y no te
        rindas! Tienes hasta el {formatStringDate(activity_dates[1])} para
        alcanzar los mejores puntajes.
      </p>

      <h4 className="--margin-top"> ¡Participa y diviértete!</h4>
    </div>
  )
}
function ContentView({ isMobile, ready }) {
  const [logged, setLogged] = useState(false)
  const userInfo = getUserInfo()
  useEffect(() => {
    setLogged(userInfo !== null)
  }, [userInfo])
  return logged ? (
    <ViewLogged userInfo={userInfo} ready={ready} />
  ) : (
    <ViewNotLoged isMobile={isMobile} />
  )
}

export function LeftSide({ isMobile, ready }) {
  const handleBtnPlay = () => {
    navigate('/play')
  }
  return (
    <aside className="f-top-section__side --left">
      <div className="f-top-section__side__top-container">
        <div className="f-top-section__side__top-container__title">
          <TopTitle isMobile={isMobile} />
        </div>
        <div className="f-top-section__side__top-container__back" />
        <ContentView isMobile={isMobile} ready={ready} />
      </div>
      <Button onClick={handleBtnPlay} tag="7A">
        ¡Clic para jugar!
      </Button>
    </aside>
  )
}
